import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AbstractBasketComponent } from '@df/basket/abstract-basket.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
@Component({
    selector: 'basket-view-submit',
    templateUrl: './basket-view-submit.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, TranslationModule, RouterLink]
})
export class BasketViewSubmitComponent extends AbstractBasketComponent {
    private router = inject(Router);

    @Input()
    link = '/checkout';

    @Input()
    basketAddConfirmationText = false;

    @Input()
    form?: NgForm;

    submit() {
        this.form && (this.form.submitAttempt = true);
        this.form?.ngSubmit.emit();
        if (this.form?.valid) {
            this.router.navigateByUrl(this.link);
        } else {
            document
                .getElementById('form')
                ?.getElementsByClassName('icon-checkbox')[0]
                .scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
}
